import request from "@/utils/request";

export function getSegments() {
  return request({
    url: `/api/guidebookv3/admin/segments/`,
    method: `get`,
  });
}

export function getSegmentsId(id, params) {
  return request({
    url: `/api/guidebookv3/admin/segments/${id}/`,
    method: `get`,
    params,
  });
}

export async function postSegments(data) {
  return request({
    url: `/api/guidebookv3/admin/segments/`,
    method: `post`,
    data,
  });
}

export function putSegmentsId(id, data, params = id) {
  return request({
    url: `/api/guidebookv3/admin/segments/${id}/`,
    method: `put`,
    params,
    data,
  });
}

export function deleteSegments(id, params) {
  return request({
    url: `/api/guidebookv3/admin/segments/${id}/`,
    method: "delete",
    params,
  });
}
